import React, { useEffect } from "react";
import { Box, Tab, Tabs, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import TeamEngagementPanel from "../../components/complex/TeamEngagementPanel";
import PageTitle from "../../components/PageTitle/PageTitle";

import SkillsChart from "../../components/Team/SkillsChart/"

export default function DashboardMarketing() {
  const theme = useTheme();

  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      <PageTitle text="My Team" />
      <Typography
        sx={{
          fontSize: theme.typography.textMD.fontSize,
          lineHeight: theme.typography.textMD.lineHeight,
          fontWeight: theme.typography.fontWeightLight,
          mb: theme.customSpacing["2xl"],
        }}
      >
        Track your team’s engagement and progress across the program, all in one
        place!
      </Typography>
      <Tabs
        value={value}
        onChange={handleChange}
        variant="fullWidth"
        TabIndicatorProps={{ style: { display: "none" } }}
        textColor={theme.palette.text.primary}
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "space-between",
          width: "100%",
          padding: 0,
          mb: theme.customSpacing["sm"],
          gap: theme.customSpacing["2xl"],
          backgroundColor: "transparent",
          "& .MuiTab-root": {
            textTransform: "none",
            width: "100%",
            fontWeight: theme.typography.fontWeightMedium,
            fontSize: theme.typography.textSM.fontSize,
            color: theme.palette.text.primary,
            padding: `${theme.customSpacing.md} ${theme.customSpacing.lg}`,
            borderRadius: "4px",
            minHeight: "unset",
            minWidth: "unset",
          },
          "& .Mui-selected": {
            backgroundColor: theme.palette.foreground.button_secondary,
            color: theme.palette.background.brand_alt,
            fontWeight: theme.typography.fontWeightRegular,
          },
          "& .Mui-disabled": {
            color: theme.palette.text.disabled,
            fontWeight: theme.typography.fontWeightRegular,
          },
        }}
      >
        <Tab label="Engagement" />
        <Tab label="Skill Progress" />
      </Tabs>
      {value === 0 && <TeamEngagementPanel />}
      {value === 1 && <SkillsChart />}
    </Box>
  );
}
